export const TABLE_PATTERN = [
  {
    isPersonalAndInsuranceStartTerm: 1,
    updatedDriverSpecialContract: 1,
    updatedDriverAgeConditionSpecialContract: 1,
    pattern: 'A',
  },
  {
    isPersonalAndInsuranceStartTerm: 1,
    updatedDriverSpecialContract: 1,
    updatedDriverAgeConditionSpecialContract: 2,
    pattern: 'B',
  },
  {
    isPersonalAndInsuranceStartTerm: 1,
    updatedDriverSpecialContract: 1,
    updatedDriverAgeConditionSpecialContract: 3,
    pattern: 'C',
  },
  {
    isPersonalAndInsuranceStartTerm: 1,
    updatedDriverSpecialContract: 1,
    updatedDriverAgeConditionSpecialContract: 4,
    pattern: 'D',
  },
  {
    isPersonalAndInsuranceStartTerm: 1,
    updatedDriverSpecialContract: 2,
    updatedDriverAgeConditionSpecialContract: 1,
    pattern: 'E',
  },
  {
    isPersonalAndInsuranceStartTerm: 1,
    updatedDriverSpecialContract: 2,
    updatedDriverAgeConditionSpecialContract: 2,
    pattern: 'F',
  },
  {
    isPersonalAndInsuranceStartTerm: 1,
    updatedDriverSpecialContract: 2,
    updatedDriverAgeConditionSpecialContract: 3,
    pattern: 'G',
  },
  {
    isPersonalAndInsuranceStartTerm: 1,
    updatedDriverSpecialContract: 2,
    updatedDriverAgeConditionSpecialContract: 4,
    pattern: 'H',
  },
  {
    isPersonalAndInsuranceStartTerm: 1,
    updatedDriverSpecialContract: 4,
    updatedDriverAgeConditionSpecialContract: 1,
    pattern: 'I',
  },
  {
    isPersonalAndInsuranceStartTerm: 1,
    updatedDriverSpecialContract: 4,
    updatedDriverAgeConditionSpecialContract: 2,
    pattern: 'J',
  },
  {
    isPersonalAndInsuranceStartTerm: 1,
    updatedDriverSpecialContract: 4,
    updatedDriverAgeConditionSpecialContract: 3,
    pattern: 'K',
  },
  {
    isPersonalAndInsuranceStartTerm: 1,
    updatedDriverSpecialContract: 4,
    updatedDriverAgeConditionSpecialContract: 4,
    pattern: 'L',
  },
];
